import React from 'react';
import { Section } from './ui/Section';
export function TomosDetail() {
  const tomos = [{
    icon: '📘',
    title: 'TOMO 1 — LA CALCULADORA DE SUPERVIVENCIA',
    desc: 'Deja de cobrar a ojo para siempre. Calcula tu tarifa mínima real con la fórmula exacta de supervivencia, tu tarifa objetivo y tu precio de posicionamiento. Incluye la calculadora paso a paso, los errores más caros al fijar precios y cómo subir tarifas a clientes actuales sin perderlos.'
  }, {
    icon: '📗',
    title: 'TOMO 2 — EL RADAR DE CLIENTES (MÉTODO SPA)',
    desc: 'El sistema de prospección diaria de 20 minutos para conseguir clientes de forma predecible. Scripts de primer contacto, seguimiento sin parecer desesperado y el método SPA (Seleccionar, Personalizar, Actuar) para llenar tu agenda sin depender de que alguien te recomiende.'
  }, {
    icon: '📙',
    title: 'TOMO 3 — LA OFICINA EN UNA PÁGINA',
    desc: 'Tu negocio completo en un solo dashboard. Control de proyectos, facturación, clientes y tareas en un sistema que puedes revisar en 10 minutos cada mañana. Incluye plantilla de Notion y Excel lista para usar desde el día 1.'
  }, {
    icon: '📕',
    title: 'TOMO 4 — CONTRATOS BLINDADOS',
    desc: 'El sistema legal simple para freelancers que no quieren estudiar derecho. Cláusulas anti cambios infinitos, protocolo de cobro por fases y qué hacer cuando un cliente no paga. Nunca más un proyecto sin límites claros.'
  }, {
    icon: '📒',
    title: 'TOMO 5 — PSICOLOGÍA DEL "SÍ"',
    desc: 'El manual completo de respuestas para las situaciones que te cuestan dinero. Cómo responder al "eres caro", al "me lo pienso", al "hazme un descuento" y al silencio post-propuesta. Scripts reales, probados y listos para copiar y pegar.'
  }, {
    icon: '📓',
    title: 'TOMO 6 — EL PLAN DE LOS 14 DÍAS',
    desc: 'La hoja de ruta de implementación para pasar del caos al sistema en dos semanas. Qué hacer cada día, en qué orden y cómo mantener el sistema funcionando a largo plazo sin que se caiga en la semana 3.'
  }];
  const features = ['Protocolo 100% listo — abrís el PDF y arrancáis hoy', 'Ejercicios de implementación inmediata', 'Plantillas y checklists descargables', 'Diseñado para freelancers con poco tiempo y mucho caos', 'Compatible con móvil, tablet y ordenador'];
  return <Section data-id="element-203">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-204">
        💪 6 TOMOS COMPLETOS
      </h2>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-205">
        {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-neutral-800 rounded-2xl p-8 hover:bg-neutral-900 transition-colors" data-id="element-206">
            <div className="text-4xl mb-4" data-id="element-207">{tomo.icon}</div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-208">{tomo.title}</h3>
            <p className="text-neutral-400 leading-relaxed" data-id="element-209">{tomo.desc}</p>
          </div>)}
      </div>

      <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-8 max-w-2xl mx-auto" data-id="element-210">
        <h4 className="text-lg font-bold mb-6 text-center" data-id="element-211">
          Cada tomo incluye:
        </h4>
        <ul className="space-y-4" data-id="element-212">
          {features.map((feat, i) => <li key={i} className="flex items-start gap-3" data-id="element-213">
              <span className="text-green-500 shrink-0" data-id="element-214">✅</span>
              <span className="text-neutral-300" data-id="element-215">{feat}</span>
            </li>)}
        </ul>
      </div>
    </Section>;
}